import React, { useState } from "react";
import { imageUrl } from "@/lib/api";
import { isPortraitSource } from "@/lib/bannerRenderer";
import { IMAGE_SLOTS } from "@/lib/companyProfile";

/* Media responsif CP — satu gambar untuk desktop & mobile. Kotak rasio tetap per slot (CSS aspect-ratio);
   fit ditentukan dari dimensi asli saat load (reuse `isPortraitSource` Store Banner, rasio < 1.0): landscape/persegi → cover,
   potret → contain di atas backdrop blur gambar yang sama (tanpa refetch). Gagal load → tidak dirender. */
export function CpImage({ slot, src, alt = "", className = "", loading = "lazy", priority = false, testId }) {
  const [fit, setFit] = useState("cover");
  const [failed, setFailed] = useState(false);
  if (!src || failed) return null;
  const url = imageUrl(src);
  const onLoad = (e) => setFit(isPortraitSource({ naturalWidth: e.target.naturalWidth, naturalHeight: e.target.naturalHeight }) ? "contain" : "cover");
  return (
    <div className={`cp-media ${className}`} style={{ aspectRatio: IMAGE_SLOTS[slot]?.ratio || "4 / 3" }} data-fit={fit} data-slot={slot} data-testid={testId}>
      {fit === "contain" ? <img src={url} alt="" aria-hidden="true" className="cp-media-backdrop" /> : null}
      <img src={url} alt={alt} loading={priority ? "eager" : loading} fetchPriority={priority ? "high" : undefined} decoding="async"
        className="cp-media-img" onLoad={onLoad} onError={() => setFailed(true)} />
    </div>
  );
}
